import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

  html,
  body {
    margin: 0;
    padding: 0px;
    box-sizing: border-box;
  

    height: 100%;
    width: 100%;
    ::-webkit-scrollbar {
    width: 10px;
  ;
    
  }
  ::-webkit-scrollbar-thumb{
    background-color: #E4DFFF;
    border-radius: 5px;
  }
  }

  body {
    font-family: 'Nunito', sans-serif;
  }

  #root {
    min-height: 100%;
    min-width: 100%;
  }

  p,
  label {
    font-family: Georgia, Times, 'Times New Roman', serif;
    line-height: 1.5em;
  }

  input, select {
    font-family: inherit;
    font-size: inherit;
  }
  
  .active-button {
    background-color: lightgrey;
    padding: 1px;
  }
  .blurred-content {
  filter: blur(2px); /* Adjust the blur effect */
  pointer-events: none; /* Prevent interaction with the blurred content */
}

`;
